
/**************************************
 * システム：ラベンリングサイト
 * 機能：全サイト共通
 * 追加者:TIE304043
 * 追加日:2021/10/4
 **************************************/

import Nuxeo from 'nuxeo/es5';


// 保守画面表示
maintenance();

/*************************************
 * 保守画面表示制御
/*************************************/
function maintenance() {

    const current_url = document.location.toString();

   // メンテナンス画面のプレフィックス設定
    var prefix = "./";
    if (current_url.indexOf("/au/") >= 0) {
        prefix = "../";
    }

	// Nuxeoクライエント
    const nuxeoClient = new Nuxeo({
        baseURL: '/nuxeo'
    });

    // 保守フラグ取得
    nuxeoClient.request('user/maintenance')
        .get()
        .then(data => {
           const flag = data.properties.company;

           // 保守モードの場合、メンテナンス画面へリダイレクト
           if ( flag  === 'true') {
               window.location.href = prefix + "maintenance.html";
           }
        })
        .catch(error => {
            console.log(error);
        });
}

